import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Table,
  Button,
} from "react-bootstrap";
import { useFormik, Field, ErrorMessage, FormikProvider } from "formik";
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import Select from "react-select";

const ClousureInfoApplDetails = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formik = useFormik({
    initialValues: {
      natureOfClosure: "",
      proposedClosureYear: "",
      justification: "",
      inst1Name: "",
      inst1Code: "",
      inst1_students: "",
      inst1_supply: "",
      inst2_name: "",
      inst2_code: "",
      inst2_students: "",
      inst2_supply: "",
    },

    validationSchema: Yup.object({
      natureOfClosure: Yup.string().required("Select Nature of Closure"),
      proposedClosureYear: Yup.number().required("Enter Closure Year"),
      justification: Yup.string().required("Enter Justification"),
      inst1Name: Yup.string().required("Enter Institution Name"),
      inst1_students: Yup.string().required("Select Option"),
      inst1_supply: Yup.string().required("Select Option"),
      inst2_name: Yup.string()
        .required("Enter Institution Name")
        .test(
          "different-institutions",
          "Institution 1 and Institution 2 cannot be the same",
          function (value) {
            const { inst1Name } = this.parent; // NOSONAR
            return value !== inst1Name;
          },
        ),
      inst2_students: Yup.string().required("Select Option"),
      inst2_supply: Yup.string().required("Select Option"),
    }),
    onSubmit: (values) => {
      postData(values);
    },
  });

  function postData(values) {
    const payload = {
      natureOfClosure: values.natureOfClosure,
      proposedClosureYear: values.proposedClosureYear,
      justification: values.justification,

      inst1Name: values.inst1Name,
      inst1Code: values.inst1Code,
      inst1Students: values.inst1_students,
      inst1Supply: values.inst1_supply,

      inst2Name: values.inst2_name,
      inst2Code: values.inst2_code,
      inst2Students: values.inst2_students,
      inst2Supply: values.inst2_supply,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit the data?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.FAC_URL + "saveClosur";
        CommonAxiosPost(url, payload).then((res) => {
          if (res !== null) {
            if (res.data.scode === "01") {
              successAlert2(res.data.sdesc);
              //   window.location.reload();
              getClosureDetails();
            } else {
              failureAlert(res.data.sdesc);
            }
          }
        });
      }
    });
  }
  const getClosureDetails = () => {
    let url = config.url.FAC_URL + "getClosureData";

    CommonAxiosGet(url)
      .then((res) => {
        if (
          res !== null &&
          res.data.status === true &&
          Array.isArray(res.data.closureData) &&
          res.data.closureData.length > 0
        ) {
          const data = res.data.closureData[0];

          setIsSubmitted(true);

          formik.setFieldValue("natureOfClosure", data.nature_of_closure || "");
          formik.setFieldValue(
            "proposedClosureYear",
            data.proposed_closure_year || "",
          );
          formik.setFieldValue("justification", data.justification || "");
          formik.setFieldValue("inst1Name", data.inst1_name || "");
          formik.setFieldValue("inst1Code", Number(data.inst1_code) || "");

          formik.setFieldValue("inst2_name", data.inst2_name || "");
          formik.setFieldValue("inst2_code", Number(data.inst2_code) || "");
          // formik.setFieldValue("inst1Name", data.inst1_name || "");
          // formik.setFieldValue("inst1Code", data.inst1_code || "");
          formik.setFieldValue("inst1_students", data.inst1_students || "");
          formik.setFieldValue("inst1_supply", data.inst1_supply || "");

          // formik.setFieldValue("inst2_name", data.inst2_name || "");
          // formik.setFieldValue("inst2_code", data.inst2_code || "");
          formik.setFieldValue("inst2_students", data.inst2_students || "");
          formik.setFieldValue("inst2_supply", data.inst2_supply || "");
        } else {
          // No data found → enable form
          setIsSubmitted(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching closure details:", error);

        setIsSubmitted(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch application details",
        });
      });
  };
  useEffect(() => {
    getClosureDetails();
    getInstitutionData();
  }, []);

  const currentYear = new Date().getFullYear();

  const years = [];
  for (let i = 0; i <= 5; i++) {
    years.push(currentYear + i);
  }
  const [getInstData, setInstData] = useState([]);
  function getInstitutionData() {
    let url = config.url.FAC_URL + "getInstdtls";
    CommonAxiosGet(url).then((res) => {
      if (res !== null) {
        if (res.data.status === true) {
          setInstData(res.data.data);
        } else {
          setInstData([]);
        }
      }
    });
  }
  const instOptions = [
    { value: "", label: "--Select--" },
    ...getInstData.map((item) => ({
      value: item.coll_code,
      label: item.inst_name,
    })),
  ];
  return (
    <>
      {/* <Container className="mt-4"> */}
      {/* <Card> */}
      {/* <Card.Header > */}
      {/* 🔒 Closure of Institution */}
      <h5 className="mb-3 innerheader-new">
        <span>
          {" "}
          <b>🔒 Closure of Institution</b>
        </span>
      </h5>

      {/* </Card.Header> */}
      <Card.Body>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row className="mb-2">
              <Col md={4}>
                <Form.Label className="fw-bold">
                  Complete Closure / Progressive closure of the Institution <span style={{ color: "red" }}>*</span>
                  <span style={{ color: "red" }}>*</span>
                </Form.Label>
              </Col>

              <Col md={2}>
                <Form.Label>
                  Closure Year <span style={{ color: "red" }}>*</span>
                </Form.Label>
              </Col>

              <Col md={6}>
                <Form.Label>
                  Justification <span style={{ color: "red" }}>*</span>
                </Form.Label>
              </Col>
            </Row>

            <Row className="mb-3 align-items-start">
              {/* Nature of Closure */}
              <Col md={4}>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    label={
                      <>
                        🕑 <b>Progressive Closure</b>
                        <br />
                        <span style={{ fontSize: "13px", color: "#6c757d" }}>
                          Phase out — no fresh admissions
                        </span>
                      </>
                    }
                    name="natureOfClosure"
                    value="progressive"
                    checked={formik.values.natureOfClosure === "progressive"}
                    onChange={formik.handleChange}
                    disabled={isSubmitted}
                  />

                  <Form.Check
                    type="radio"
                    label={
                      <>
                        🔒 <b>Complete Closure</b>
                        <br />
                        <span style={{ fontSize: "13px", color: "#6c757d" }}>
                          Immediate closure
                        </span>
                      </>
                    }
                    name="natureOfClosure"
                    value="complete"
                    checked={formik.values.natureOfClosure === "complete"}
                    onChange={formik.handleChange}
                    disabled={isSubmitted}
                  />
                </div>

                <ErrorMessage
                  name="natureOfClosure"
                  component="div"
                  className="text-danger"
                />
              </Col>

              {/* Closure Year */}
              <Col md={2}>
                <Field
                  as="select"
                  name="proposedClosureYear"
                  className="form-control"
                  disabled={isSubmitted}
                >
                  <option value="">Year</option>

                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Field>

                <ErrorMessage
                  name="proposedClosureYear"
                  component="div"
                  className="text-danger"
                />
              </Col>

              {/* Justification */}
              <Col md={5}>
                <Field
                  as="textarea"
                  name="justification"
                  rows={3}
                  disabled={isSubmitted}
                  placeholder="Please provide detailed justification..."
                  className={`form-control ${formik.touched.justification && formik.errors.justification
                    ? "is-invalid"
                    : ""
                    }`}
                  style={{ height: "120px", resize: "vertical" }}
                />

                <ErrorMessage
                  name="justification"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>

            {/* Table */}
            <Row className="mt-4">
              <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                {/* <h6 className="fw-bold mb-3">
                                        Recipient Institution(s)
                                    </h6> */}
                <h5 className="mb-3 innerheader-new">
                  <span>
                    {" "}
                    <b>Recipient Institution(s)</b>
                  </span>
                </h5>
                <Table bordered responsive>
                  <thead style={{ background: "#0f2235", color: "white" }}>
                    <tr>
                      <th>Details</th>
                      <th>Recipient Institution 1</th>
                      <th>Recipient Institution 2</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Institution Name</td>
                      <td>
                        <Select
                          options={instOptions}
                          placeholder="Search Institution"
                          isDisabled={isSubmitted}
                          value={instOptions.find(
                            (option) =>
                              option.value === formik.values.inst1Code,
                          )}
                          // onChange={(selectedOption) => {

                          //     const selectedCode = selectedOption.value;

                          //     formik.setFieldValue("inst1Name", selectedCode);
                          //     formik.setFieldValue("inst1Code", selectedCode);

                          // }}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              const selectedCode = selectedOption.value;
                              const selectedName = selectedOption.label;

                              formik.setFieldValue("inst1Code", selectedCode);
                              formik.setFieldValue("inst1Name", selectedName);
                            }
                          }}
                        />

                        <ErrorMessage
                          name="inst1Name"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Select
                          options={instOptions}
                          placeholder="Search Institution"
                          isDisabled={isSubmitted}
                          value={instOptions.find(
                            (option) =>
                              option.value === formik.values.inst2_code,
                          )}
                          onChange={(selectedOption) => {
                            //     const code = selectedOption.value;

                            //     formik.setFieldValue("inst2_name", code);
                            //     formik.setFieldValue("inst2_code", code);
                            //   }}
                            if (selectedOption) {
                              const code = selectedOption.value;
                              const name = selectedOption.label;
                              formik.setFieldValue("inst2_code", code);
                              formik.setFieldValue("inst2_name", name);
                            } else {
                              formik.setFieldValue("inst2_code", "");
                              formik.setFieldValue("inst2_name", "");
                            }
                          }}
                        />

                        <ErrorMessage
                          name="inst2_name"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Institution Code </td>
                      <td>
                        <Field
                          name="inst1Code"
                          className="form-control"
                          disabled
                          value={formik.values.inst1Code}
                        />
                        {/* <ErrorMessage name="inst1Code" component="div" className="text-danger" /> */}
                      </td>
                      <td>
                        <Field
                          name="inst2_code"
                          className="form-control"
                          disabled
                        />
                        {/* <ErrorMessage name="inst2_code" component="div" className="text-danger" /> */}
                      </td>
                    </tr>
                    <tr>
                      <td>Undertaking to take students</td>
                      <td>
                        <Field
                          name="inst1_students"
                          as="select"
                          className="form-select"
                          disabled={isSubmitted}
                        >
                          <option value="">Select</option>
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </Field>

                        <ErrorMessage
                          name="inst1_students"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          name="inst2_students"
                          as="select"
                          className="form-select"
                          disabled={isSubmitted}
                        >
                          <option value="">Select</option>
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </Field>
                        <ErrorMessage
                          name="inst2_students"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Undertaking for supplementary exams</td>
                      <td>
                        <Field
                          name="inst1_supply"
                          as="select"
                          className="form-select"
                          disabled={isSubmitted}
                        >
                          <option value="">Select</option>
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </Field>

                        <ErrorMessage
                          name="inst1_supply"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                      <td>
                        <Field
                          name="inst2_supply"
                          as="select"
                          className="form-select"
                          disabled={isSubmitted}
                        >
                          <option value="">Select</option>
                          <option value="YES">YES</option>
                          <option value="NO">NO</option>
                        </Field>
                        <ErrorMessage
                          name="inst2_supply"
                          component="div"
                          className="text-danger"
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            {isSubmitted ? (
              <div className="mt-3 text-end text-success">
                ✅ Already Submitted
              </div>
            ) : (
              <Row className="mt-4">
                <Col className="text-end">
                  <Button
                    className="btn-primary"
                    type="submit"
                    variant="primary"
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
        </FormikProvider>
      </Card.Body>
    </>
  );
};
export default ClousureInfoApplDetails;